import { Link } from "react-router-dom";

export type StudentAssignmentGateKind = "closed" | "not_open";

const COPY: Record<StudentAssignmentGateKind, { title: string; body: string }> = {
  closed: {
    title: "Sorry, this assignment is closed",
    body: "Your teacher has closed this lesson. If you think this is a mistake, ask them to reopen it or check your lessons list.",
  },
  not_open: {
    title: "This assignment is not open yet",
    body: "Your teacher has not opened this lesson for your class yet. Check back later or open it from your lessons list when it appears.",
  },
};

export interface StudentAssignmentGatePageProps {
  readonly kind: StudentAssignmentGateKind;
  readonly lessonTitle?: string;
}

export function StudentAssignmentGatePage({ kind, lessonTitle }: StudentAssignmentGatePageProps) {
  const copy = COPY[kind];
  return (
    <main className="page">
      <div className="card card-wide student-assignment-gate">
        <p className="eyebrow">Student</p>
        <h1>{copy.title}</h1>
        {lessonTitle ? (
          <p className="lede" style={{ marginTop: "0.35rem" }}>
            {lessonTitle}
          </p>
        ) : null}
        <p className="muted">{copy.body}</p>
        <Link to="/lessons" className="btn secondary">
          Back to lessons
        </Link>
      </div>
    </main>
  );
}
